import React from 'react'
import { TabProps } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumLeaderboardTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: '8px',
      minHeight: '40px',
      minWidth: 'auto',
      textTransform: 'none',
      borderRadius: '8px',
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '16px',
      whiteSpace: 'nowrap',
    },
    textColorPrimary: {
      color: theme.palette.text.primary,
      opacity: 0.4,
    },
    selected: {
      opacity: 1,
    },
    wrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  }),
)(({ classes, ...props }: TabProps) => {
  return <Tab classes={classes} {...props} />
})

export default YumLeaderboardTab
